import {PersonInfo} from "../../../interfaces/getDarInfo_interface";
import React from "react";
import { Disclosure } from '@headlessui/react'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ProfessionInfo from "../../../interfaces/ProfessionInfo.interface";
import { TablePagination, CircularProgress } from "@mui/material";
import ProfesionIcon from "../../../assets/Images/profession1.png";
import {
    ColumnDirective,
    ColumnsDirective,
    GridComponent ,
    Grid,
    Inject,
    Page,
    Sort,
    Filter,
    DetailRow,
    ExcelExport,
    PdfExport,
    Toolbar,
    Search
} from '@syncfusion/ej2-react-grids';

interface PanelProfessionsProps {
    person: PersonInfo,
    Professions: ProfessionInfo[],
    isLoading:boolean
}

const  PanelProfession: React.FC<PanelProfessionsProps> = ({person,Professions,isLoading})=> {
    const [FormatData, setFormatData] = React.useState(0);

    const handleDataTyping = () => {
        let tempP: any = [...Professions]
        for (let p of tempP) {
            if (p.IssueDate) {
                p.IssueDate = new Date(p.IssueDate)
            }
            if (p.ExpirationDate) {
                p.ExpirationDate = new Date(p.ExpirationDate)
            }
        }
        setFormatData(tempP)
    }

    React.useEffect(() => {
        handleDataTyping()
    }, [Professions])

    return(
        <div className={"m-5 border"}>
            <Disclosure >
                {({ open }) => (
                    <>
                       <Disclosure.Button className="bg-blue-100 p-2 w-auto w-full text-left">
                            <span style={{ "display": "flex", "justifyContent": "space-between" }}>
                                <span>
                                    <KeyboardArrowDownIcon
                                        className={`${open ? "transform rotate-180" : ""}`}
                                    />
                                    <span className={"font-bold"}>Profession (Name Match ONLY) <img src={ProfesionIcon} alt={''} style={{ display: 'inline' }} /> {(isLoading) ? <CircularProgress size={20} style={{"marginLeft" : "5px"}} /> : <></>}</span>
                                </span>
                                <span className={"font-bold mr-2"} >Name: {person?.FName?.toUpperCase()} {person?.MName?.toUpperCase()} {person?.LName?.toUpperCase()} &nbsp;&nbsp;Records: {Professions?.length}</span>
                            </span>
                       </Disclosure.Button>
                    
                        <Disclosure.Panel className="text-gray-500 p-4">

                            <GridComponent
                                dataSource={FormatData}
                                allowPaging={true}
                                pageSettings={{pageSize: 50, pageSizes: [10,25,50,100]}}
                                allowSorting={true}
                                allowMultiSorting={true}
                                allowFiltering={true}
                                filterSettings={{type: 'CheckBox'}}
                                allowTextWrap={true}
                                textWrapSettings={{ wrapMode: 'Both' }}
                                rowHeight={24}
                            >
                                <ColumnsDirective>
                                    <ColumnDirective field='IssueDate' headerText='Issue Date' format={{ type: 'date', format: 'MM/dd/yyyy' }}/>
                                    <ColumnDirective field='ExpirationDate' headerText='Expiration Date' format={{ type: 'date', format: 'MM/dd/yyyy' }}/>
                                    <ColumnDirective field='ProfessionName' headerText='Profession'/>
                                    <ColumnDirective field='LicenseName' headerText='License Name'/>
                                    <ColumnDirective field='LicenseNo' headerText='License #'/>
                                    <ColumnDirective field='Status' headerText='License Status'/>
                                    <ColumnDirective template={(item: any) => (<>{item?.StreetNo} {item?.StreetName} {item?.City} {item?.State} {item?.Zip}</>)} headerText='Address'/>
                                    {/*<ColumnDirective field='ID' headerText='ID'/>*/}
                                </ColumnsDirective>
                                <Inject services={[Sort, Page, Filter]}/>
                            </GridComponent>
                            
                        </Disclosure.Panel>
                    </>
                )}
            </Disclosure>
        </div>
        
    )
};

export default PanelProfession;